import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../modules/helpActions'
import * as api from '../api/help'

function* fetchHelp(action) {
  try {
    const payload = yield call(api.getAllHelp, action)
    yield put({ type: constants.HELP_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.HELP_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* helpRefresh() {
  yield takeLatest(constants.HELP_REFRESH.ACTION, fetchHelp)
}

export function* getAllHelp(action) {
  try {
    const payload = yield call(api.getAllHelp)
    yield put({ type: constants.GET_ALL_HELP.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_ALL_HELP.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAllHelp() {
  yield takeLatest(constants.GET_ALL_HELP.ACTION, getAllHelp)
}

function* createHelp(action) {
  try {
    const payload = {
      title: action.content.title,
      body: action.content.body,
      created_date: action.content.created_date,
      updated_date: action.content.updated_date,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }
    yield call(api.createHelp, payload)
    yield put({ type: constants.CREATE_HELP.SUCCESS, payload })
    yield call(fetchHelp)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_HELP.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateHelp() {
  yield takeLatest(constants.CREATE_HELP.ACTION, createHelp)
}

function* editHelp(action) {
  try {
    const payload = {
      content: action.content,
      helpId: action.helpId
    }
    yield call(api.editHelp, payload)
    yield put({ type: constants.EDIT_HELP.SUCCESS, payload })
    yield call(fetchHelp)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EDIT_HELP.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditHelp() {
  yield takeLatest(constants.EDIT_HELP.ACTION, editHelp)
}

function* deleteHelp(action) {
  try {
    const payload = {
      helpId: action.helpId
    }
    yield call(api.deleteHelp, payload)
    yield put({ type: constants.DELETE_HELP.SUCCESS, payload })
    yield call(fetchHelp)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_HELP.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteHelp() {
  yield takeLatest(constants.DELETE_HELP.ACTION, deleteHelp)
}

// ATTACHMENT SAGAS
function* uploadAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      helpId: action.helpId
    }

    yield call(api.uploadAttachments, payload)
    yield put({ type: constants.UPLOAD_HELP_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { helpId: action.helpId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_HELP_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadAttachments() {
  yield takeLatest(constants.UPLOAD_HELP_ATTACHMENT.ACTION, uploadAttachments)
}

function* getAttachments(action) {
  try {
    const payload = yield call(api.getAttachments, action.helpId)
    yield put({ type: constants.GET_HELP_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_HELP_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAttachments() {
  yield takeLatest(constants.GET_HELP_ATTACHMENTS.ACTION, getAttachments)
}

function* updateAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      user_id: 1,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_HELP_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getAttachments, { helpId: action.helpId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_HELP_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateAttachmentDescription() {
  yield takeLatest(constants.UPDATE_HELP_ATTACHMENT_DESCRIPTION.ACTION, updateAttachmentDescription)
}

function* deleteAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      helpId: action.helpId
    }

    yield call(api.deleteAttachment, payload)
    yield put({ type: constants.DELETE_HELP_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { helpId: action.helpId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_HELP_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteAttachments() {
  yield takeLatest(constants.DELETE_HELP_ATTACHMENT.ACTION, deleteAttachment)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  yield all([
    fork(helpRefresh),
    fork(watchGetAllHelp),
    fork(watchCreateHelp),
    fork(watchEditHelp),
    fork(watchDeleteHelp),

    fork(watchUploadAttachments),
    fork(watchGetAttachments),
    fork(watchUpdateAttachmentDescription),
    fork(watchDeleteAttachments)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/helpSaga.js